import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { MaybeRef } from "vue";
import { computed, toValue } from "vue";
import type { TodoSubmission } from "@/components/MyStudentDetail/FilterableTodosSection/types";
import { profileServiceRequest } from "@/services/utils";

interface TodosSubmissionsListResponse {
  items: TodoSubmission[];
  count: number;
  start: number;
  end: number;
}

export const getTodosSubmissionsQueryKey = (participantId: MaybeRef<string | undefined>) => [
  "todos-submissions",
  toValue(participantId),
];

export const useGetTodosSubmissions = <TData = TodoSubmission[]>(
  participantId: MaybeRef<string | undefined>,
  useQueryOptions?: Partial<UseQueryOptions<TodoSubmission[], Error, TData>>,
) => {
  const queryKey = computed(() => getTodosSubmissionsQueryKey(participantId));

  return useQuery<TodoSubmission[], Error, TData>({
    queryKey,
    queryFn: async (): Promise<TodoSubmission[]> => {
      const id = toValue(participantId);
      const response = await profileServiceRequest({
        method: "get",
        url: `/onboarding/todos_submissions/${id}/`,
        params: { limit: 100, get_archived: true },
      });
      const data: TodosSubmissionsListResponse = response?.data?.data ?? response?.data;
      return data?.items ?? [];
    },
    ...useQueryOptions,
  });
};
